import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_product",
  ref: "addProductModalRef",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  style: {"max-width":"1100px !important"}
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Add Product", -1)
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body py-lg-10 px-lg-10" }
const _hoisted_8 = { class: "d-flex flex-column gap-7 gap-lg-10 w-100 w-lg-300px mb-7 me-lg-10" }
const _hoisted_9 = { class: "card card-flush py-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h2", { required: "" }, "Product Image"),
    /*#__PURE__*/_createElementVNode("label", { class: "required" })
  ])
], -1)
const _hoisted_11 = { class: "card-body pt-0" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = {
  class: "image-input image-input-empty image-input-outline mb-3",
  "data-kt-image-input": "true",
  style: {}
}
const _hoisted_14 = {
  class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow",
  "data-kt-image-input-action": "change",
  "data-bs-toggle": "tooltip",
  title: "Change logo"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-fill fs-7" }, null, -1)
const _hoisted_16 = { class: "fv-plugins-message-container" }
const _hoisted_17 = { class: "fv-help-block" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, " Image of product as shown on website. ", -1)
const _hoisted_19 = { class: "card card-flush py-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Fullfillment Type"),
    /*#__PURE__*/_createElementVNode("label", { class: "required" })
  ])
], -1)
const _hoisted_21 = { class: "card-body pt-0" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("option", { value: "Shipped" }, "Shipped", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("option", { value: "Downloaded" }, "Downloaded", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("option", { value: "Serviced" }, "Serviced", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("option", { value: "Saas" }, "Saas", -1)
const _hoisted_26 = { class: "fv-plugins-message-container" }
const _hoisted_27 = { class: "fv-help-block" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, " Select the method that the product is fullfilled. ", -1)
const _hoisted_29 = { class: "d-flex flex-column flex-row-fluid" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("ul", { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-bold mb-n2" }, null, -1)
const _hoisted_31 = { class: "tab-content" }
const _hoisted_32 = {
  class: "tab-pane fade show active",
  id: "kt_ecommerce_edit_product_general",
  role: "tab-panel"
}
const _hoisted_33 = { class: "d-flex flex-column" }
const _hoisted_34 = { class: "card card-flush py-4" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Product Details")
  ])
], -1)
const _hoisted_36 = { class: "card-body pt-0" }
const _hoisted_37 = { class: "d-flex flex-wrap gap-5 mb-8" }
const _hoisted_38 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Name", -1)
const _hoisted_40 = { class: "fv-plugins-message-container" }
const _hoisted_41 = { class: "fv-help-block" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, " Set the product name. ", -1)
const _hoisted_43 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Category", -1)
const _hoisted_45 = { class: "fv-plugins-message-container" }
const _hoisted_46 = { class: "fv-help-block" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, " Set the product category. ", -1)
const _hoisted_48 = { class: "d-flex flex-wrap gap-5 mb-8" }
const _hoisted_49 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "ID", -1)
const _hoisted_51 = { class: "fv-plugins-message-container" }
const _hoisted_52 = { class: "fv-help-block" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, " Set the unique product id. ", -1)
const _hoisted_54 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Price", -1)
const _hoisted_56 = { class: "fv-plugins-message-container" }
const _hoisted_57 = { class: "fv-help-block" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, " Product price shown on website. ", -1)
const _hoisted_59 = { class: "mb-8 fv-row" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Description", -1)
const _hoisted_61 = { class: "fv-plugins-message-container" }
const _hoisted_62 = { class: "fv-help-block" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, " Product Description as shown on website. ", -1)
const _hoisted_64 = { class: "d-flex flex-wrap gap-5 mb-8" }
const _hoisted_65 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "SKU", -1)
const _hoisted_67 = { class: "fv-plugins-message-container" }
const _hoisted_68 = { class: "fv-help-block" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, " Enter the SKU or 2D code. ", -1)
const _hoisted_70 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Product Status", -1)
const _hoisted_72 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold text-gray-400" }, " ON/OFF ", -1)
const _hoisted_74 = { class: "fv-plugins-message-container" }
const _hoisted_75 = { class: "fv-help-block" }
const _hoisted_76 = {
  key: 0,
  class: "row row-cols-1 row-cols-md-3 row-cols-lg-1 row-cols-xl-3 g-9",
  "data-kt-buttons": "true",
  "data-kt-buttons-target": "[data-kt-button='true']"
}
const _hoisted_77 = { class: "col" }
const _hoisted_78 = {
  class: "btn btn-outline btn-outline-dashed btn-outline-default d-flex text-start p-6",
  "data-kt-button": "true"
}
const _hoisted_79 = /*#__PURE__*/_createElementVNode("span", { class: "ms-5" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-4 fw-bolder text-gray-800 d-block" }, "Straight Sale")
], -1)
const _hoisted_80 = { class: "col" }
const _hoisted_81 = { class: "form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("span", { class: "ms-5" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-4 fw-bolder text-gray-800 d-block" }, "Free Trial")
], -1)
const _hoisted_83 = { class: "col" }
const _hoisted_84 = { class: "form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("span", { class: "ms-5" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-4 fw-bolder text-gray-800 d-block" }, "Subscription")
], -1)
const _hoisted_86 = {
  key: 1,
  class: "fv-plugins-message-container"
}
const _hoisted_87 = { class: "fv-help-block" }
const _hoisted_88 = { class: "card card-flush py-4" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Shipping")
  ])
], -1)
const _hoisted_90 = { class: "card-body pt-0" }
const _hoisted_91 = { class: "fv-row" }
const _hoisted_92 = { class: "form-check form-check-custom form-check-solid mb-2" }
const _hoisted_93 = { class: "fv-plugins-message-container" }
const _hoisted_94 = { class: "fv-help-block" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "This is a physical product", -1)
const _hoisted_96 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, " Set if the product is a physical or digital item. Physical products may require shipping. ", -1)
const _hoisted_97 = { class: "card-body pt-0" }
const _hoisted_98 = {
  key: 0,
  class: "mb-8 fv-row"
}
const _hoisted_99 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Shipping Provider", -1)
const _hoisted_100 = { class: "fv-plugins-message-container" }
const _hoisted_101 = { class: "fv-help-block" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, " Assign your Shipping Carrrier. ", -1)
const _hoisted_103 = {
  key: 1,
  class: "d-flex flex-wrap gap-5"
}
const _hoisted_104 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tax Class", -1)
const _hoisted_106 = /*#__PURE__*/_createElementVNode("option", { value: "Tax Free" }, "Tax Free", -1)
const _hoisted_107 = /*#__PURE__*/_createElementVNode("option", { value: "Taxable Goods" }, " Taxable Goods ", -1)
const _hoisted_108 = /*#__PURE__*/_createElementVNode("option", { value: "Downloadable Product" }, " Downloadable Product ", -1)
const _hoisted_109 = { class: "fv-plugins-message-container" }
const _hoisted_110 = { class: "fv-help-block" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, " Set the product tax class. ", -1)
const _hoisted_112 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "VAT Amount (%)", -1)
const _hoisted_114 = { class: "fv-plugins-message-container" }
const _hoisted_115 = { class: "fv-help-block" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, " Set the product VAT about. ", -1)
const _hoisted_117 = { class: "d-flex justify-content-end py-10" }
const _hoisted_118 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_ecommerce_edit_product_submit",
  class: "btn btn-primary"
}
const _hoisted_119 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, "Submit", -1)
const _hoisted_120 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode("Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_121 = [
  _hoisted_119,
  _hoisted_120
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            class: "btn btn-sm btn-icon btn-active-color-primary",
            "data-bs-dismiss": "modal",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
          }, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Form, {
            class: "form d-flex flex-column flex-lg-row",
            onSubmit: _ctx.onSubmit,
            "validation-schema": _ctx.product
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", {
                          class: "image-input-wrapper w-150px h-150px",
                          style: _normalizeStyle(`background-image: url(${_ctx.newProduct.product_url})`)
                        }, null, 4),
                        _createElementVNode("label", _hoisted_14, [
                          _hoisted_15,
                          _createVNode(_component_Field, {
                            type: "file",
                            name: "logo",
                            accept: ".png, .jpg, .jpeg",
                            onChange: _ctx.uploadLogo
                          }, null, 8, ["onChange"])
                        ])
                      ])
                    ]),
                    _createVNode(_component_Field, {
                      class: "form-control mb-2",
                      type: "text",
                      placeholder: "",
                      name: "product_url",
                      modelValue: _ctx.newProduct.product_url,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newProduct.product_url) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_ErrorMessage, { name: "product_url" })
                      ])
                    ]),
                    _hoisted_18
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_Field, {
                      name: "fulfill_type",
                      class: "form-select mb-2",
                      "data-control": "select2",
                      "data-hide-search": "true",
                      "data-placeholder": "Select an option",
                      as: "select",
                      modelValue: _ctx.newProduct.fulfill_type,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newProduct.fulfill_type) = $event))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_22,
                        _hoisted_23,
                        _hoisted_24,
                        _hoisted_25
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_ErrorMessage, { name: "fulfill_type" })
                      ])
                    ]),
                    _hoisted_28
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _hoisted_35,
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("div", _hoisted_38, [
                              _hoisted_39,
                              _createVNode(_component_Field, {
                                class: "form-control text-muted fs-7 mb-2",
                                type: "text",
                                name: "product_name",
                                modelValue: _ctx.newProduct.product_name,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newProduct.product_name) = $event))
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("div", _hoisted_40, [
                                _createElementVNode("div", _hoisted_41, [
                                  _createVNode(_component_ErrorMessage, { name: "product_name" })
                                ])
                              ]),
                              _hoisted_42
                            ]),
                            _createElementVNode("div", _hoisted_43, [
                              _hoisted_44,
                              _createVNode(_component_Field, {
                                class: "form-control text-muted fs-7 mb-2",
                                type: "text",
                                name: "product_category",
                                modelValue: _ctx.newProduct.product_category,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newProduct.product_category) = $event))
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("div", _hoisted_45, [
                                _createElementVNode("div", _hoisted_46, [
                                  _createVNode(_component_ErrorMessage, { name: "product_category" })
                                ])
                              ]),
                              _hoisted_47
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("div", _hoisted_49, [
                              _hoisted_50,
                              _createVNode(_component_Field, {
                                class: "form-control text-muted fs-7 mb-2",
                                type: "text",
                                name: "product_id",
                                modelValue: _ctx.newProduct.product_id,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newProduct.product_id) = $event))
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("div", _hoisted_51, [
                                _createElementVNode("div", _hoisted_52, [
                                  _createVNode(_component_ErrorMessage, { name: "product_id" })
                                ])
                              ]),
                              _hoisted_53
                            ]),
                            _createElementVNode("div", _hoisted_54, [
                              _hoisted_55,
                              _createVNode(_component_Field, {
                                class: "form-control text-muted fs-7 mb-2",
                                type: "text",
                                name: "product_price",
                                modelValue: _ctx.newProduct.product_price,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newProduct.product_price) = $event))
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("div", _hoisted_56, [
                                _createElementVNode("div", _hoisted_57, [
                                  _createVNode(_component_ErrorMessage, { name: "product_price" })
                                ])
                              ]),
                              _hoisted_58
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_59, [
                            _hoisted_60,
                            _createVNode(_component_Field, {
                              class: "form-control mb-2",
                              type: "text",
                              name: "product_description",
                              modelValue: _ctx.newProduct.product_description,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newProduct.product_description) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_61, [
                              _createElementVNode("div", _hoisted_62, [
                                _createVNode(_component_ErrorMessage, { name: "product_description" })
                              ])
                            ]),
                            _hoisted_63
                          ]),
                          _createElementVNode("div", _hoisted_64, [
                            _createElementVNode("div", _hoisted_65, [
                              _hoisted_66,
                              _createVNode(_component_Field, {
                                class: "form-control mb-2",
                                type: "text",
                                name: "product_sku",
                                modelValue: _ctx.newProduct.product_sku,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newProduct.product_sku) = $event))
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("div", _hoisted_67, [
                                _createElementVNode("div", _hoisted_68, [
                                  _createVNode(_component_ErrorMessage, { name: "product_sku" })
                                ])
                              ]),
                              _hoisted_69
                            ]),
                            _createElementVNode("div", _hoisted_70, [
                              _hoisted_71,
                              _createElementVNode("label", _hoisted_72, [
                                _createVNode(_component_Field, {
                                  class: "form-check-input",
                                  type: "checkbox",
                                  value: "On",
                                  "unchecked-value": "Off",
                                  name: "product_status",
                                  modelValue: _ctx.newProduct.product_status,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newProduct.product_status) = $event))
                                }, null, 8, ["modelValue"]),
                                _hoisted_73
                              ]),
                              _createElementVNode("div", _hoisted_74, [
                                _createElementVNode("div", _hoisted_75, [
                                  _createVNode(_component_ErrorMessage, { name: "product_status" })
                                ])
                              ])
                            ])
                          ]),
                          (_ctx.newProduct.fulfill_type !== 'Serviced')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                _createElementVNode("div", _hoisted_77, [
                                  _createElementVNode("label", _hoisted_78, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1", 
                                  _ctx.newProduct.purchase_type ===
                                    'Straight Sale' && 'active'
                                ])
                                    }, [
                                      _createVNode(_component_Field, {
                                        class: "form-check-input",
                                        type: "radio",
                                        name: "purchase_type",
                                        value: "Straight Sale",
                                        modelValue: _ctx.newProduct.purchase_type,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newProduct.purchase_type) = $event))
                                      }, null, 8, ["modelValue"])
                                    ], 2),
                                    _hoisted_79
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_80, [
                                  _createElementVNode("label", {
                                    class: _normalizeClass(["btn btn-outline btn-outline-dashed btn-outline-default d-flex text-start p-6", 
                                _ctx.newProduct.purchase_type === 'Free Trial' &&
                                'active'
                              ]),
                                    "data-kt-button": "true"
                                  }, [
                                    _createElementVNode("span", _hoisted_81, [
                                      _createVNode(_component_Field, {
                                        class: "form-check-input",
                                        type: "radio",
                                        name: "purchase_type",
                                        value: "Free Trial",
                                        modelValue: _ctx.newProduct.purchase_type,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newProduct.purchase_type) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _hoisted_82
                                  ], 2)
                                ]),
                                _createElementVNode("div", _hoisted_83, [
                                  _createElementVNode("label", {
                                    class: _normalizeClass(["btn btn-outline btn-outline-dashed btn-outline-default d-flex text-start p-6", 
                                _ctx.newProduct.purchase_type === 'Subscription' &&
                                'active'
                              ]),
                                    "data-kt-button": "true"
                                  }, [
                                    _createElementVNode("span", _hoisted_84, [
                                      _createVNode(_component_Field, {
                                        class: "form-check-input",
                                        type: "radio",
                                        name: "purchase_type",
                                        value: "Subscription",
                                        modelValue: _ctx.newProduct.purchase_type,
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newProduct.purchase_type) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _hoisted_85
                                  ], 2)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.newProduct.fulfill_type !== 'Serviced')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                _createElementVNode("div", _hoisted_87, [
                                  _createVNode(_component_ErrorMessage, { name: "purchase_type" })
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_88, [
                        _hoisted_89,
                        _createElementVNode("div", _hoisted_90, [
                          _createElementVNode("div", _hoisted_91, [
                            _createElementVNode("div", _hoisted_92, [
                              _createVNode(_component_Field, {
                                class: "form-check-input",
                                type: "checkbox",
                                id: "physical_product_checkbox",
                                value: "1",
                                "unchecked-value": "0",
                                name: "physical_product",
                                modelValue: _ctx.newProduct.physical_product,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newProduct.physical_product) = $event))
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("div", _hoisted_93, [
                                _createElementVNode("div", _hoisted_94, [
                                  _createVNode(_component_ErrorMessage, { name: "physical_product" })
                                ])
                              ]),
                              _hoisted_95
                            ]),
                            _hoisted_96
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_97, [
                          (_ctx.newProduct.physical_product === '1')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                _hoisted_99,
                                _createVNode(_component_Field, {
                                  class: "form-control mb-2",
                                  type: "text",
                                  name: "shipping_carrier",
                                  placeholder: "Shipping Carrier",
                                  modelValue: _ctx.newProduct.shipping_carrier,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newProduct.shipping_carrier) = $event))
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("div", _hoisted_100, [
                                  _createElementVNode("div", _hoisted_101, [
                                    _createVNode(_component_ErrorMessage, { name: "shipping_carrier" })
                                  ])
                                ]),
                                _hoisted_102
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.newProduct.physical_product === '1')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                _createElementVNode("div", _hoisted_104, [
                                  _hoisted_105,
                                  _createVNode(_component_Field, {
                                    name: "tax_class",
                                    class: "form-select mb-2",
                                    "data-control": "select2",
                                    "data-hide-search": "true",
                                    "data-placeholder": "Select an option",
                                    as: "select",
                                    modelValue: _ctx.newProduct.tax_class,
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.newProduct.tax_class) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_106,
                                      _hoisted_107,
                                      _hoisted_108
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]),
                                  _createElementVNode("div", _hoisted_109, [
                                    _createElementVNode("div", _hoisted_110, [
                                      _createVNode(_component_ErrorMessage, { name: "tax_class" })
                                    ])
                                  ]),
                                  _hoisted_111
                                ]),
                                _createElementVNode("div", _hoisted_112, [
                                  _hoisted_113,
                                  _createVNode(_component_Field, {
                                    class: "form-control mb-2",
                                    type: "text",
                                    name: "shipping_tax",
                                    modelValue: _ctx.newProduct.shipping_tax,
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newProduct.shipping_tax) = $event))
                                  }, null, 8, ["modelValue"]),
                                  _createElementVNode("div", _hoisted_114, [
                                    _createElementVNode("div", _hoisted_115, [
                                      _createVNode(_component_ErrorMessage, { name: "shipping_tax" })
                                    ])
                                  ]),
                                  _hoisted_116
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_117, [
                            _createElementVNode("button", {
                              class: "btn btn-light me-5",
                              "data-bs-dismiss": "modal",
                              onClick: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)), ["prevent"]))
                            }, " Cancel "),
                            _createElementVNode("button", _hoisted_118, _hoisted_121, 512)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ])
    ])
  ], 512))
}